// Default disclaimer + booking-terms templates baked into the client.
// Tenants can override these in 設定 → 條款. When the column is NULL or empty,
// the customer-facing booking flow falls back to these defaults so a shop is
// never "missing" terms.

export const DEFAULT_DISCLAIMER_SENIOR = `本店尊重每一隻長者毛孩。如毛孩屬於下列情況之一：
• 年齡 10 歲或以上
• 患有心臟病、糖尿病、癲癇、關節炎等慢性疾病
• 服用長期藥物
• 視力／聽力衰退
• 行動不便或容易緊張

由於高齡或患病毛孩在美容過程中可能因壓力、體力或既有狀況而出現突發不適，本店保留決定是否提供／中止服務之權利。如選擇繼續，毛孩家長須了解並同意：

1. 美容師會以最溫和、最快速的方式完成必要清潔，不一定能達到一般標準成品。
2. 過程中若毛孩出現任何不適（喘、抖、虛弱、嘔吐等），本店會立即中止並通知家長，已產生費用照計。
3. 若因毛孩既有狀況導致任何不可預測之意外、傷害或健康變化，本店不承擔法律責任。

家長簽署即表示已閱讀並理解上述條款，並同意以家長身份為毛孩承擔風險。`;

export const DEFAULT_TERMS_BOOKING = `預約須知 — 請於確認前細閱：

1. 訂金：預約須繳交訂金以保留時段，金額按本店訂金政策計算。

2. 改期 / 取消：
   • 預約時間 24 小時前取消：訂金可全額退還
   • 預約時間 24 小時內取消：訂金不予退還
   • 未到店：訂金不予退還，並會記錄

3. 遲到：請準時到店；遲到 15 分鐘以上恕無法保留原時段，可能需要安排當日其他時段或改期。

4. 健康狀況：請預先告知任何身體不適、傳染病、皮膚病或行為敏感；如未告知而引致美容師受傷或他犬感染，家長須負相關責任。

5. 已絕育／未絕育、發情期：請於預約時註明。

6. 拍照：本店有可能在美容後拍攝完成照片用於記錄及社交媒體；如不同意請於到店時告知。

7. 失物：如有遺留物品（牽繩、玩具、衣物等），請於 30 日內聯絡領回；逾期將不予保留。

8. 私隱：客戶資料只用於本店服務通知，不會出售或分享予第三方。

點擊「同意條款並繼續」即代表你已閱讀並接受上述全部條款。`;

// Cat-specific booking notice — shown when the pet being booked is a cat
// (pet.type === "cat"). Overridable via 設定 → 條款 → 貓貓美容預約須知.
export const DEFAULT_TERMS_CAT = `貓貓美容預約須知 — 請於確認前細閱：

1. 預約前評估：貓貓對美容環境較敏感，請於預約時誠實告知性格（怕生、容易咬／抓、有無美容經驗）及任何健康狀況，以便安排合適流程。

2. 疫苗紀錄：建議貓貓持有有效三合一疫苗紀錄；首次到店請出示疫苗證明。

3. 安全處理：如貓貓在過程中出現極度抗拒、過度緊張或攻擊行為，美容師會立即中止服務以保護貓貓及自身安全，已產生費用照計。

4. 麻醉服務：本店一律不提供麻醉式美容（Tranquilizer-free policy）。如貓貓必須要麻醉才能洗澡或剃毛，請聯絡獸醫診所進行。

5. 剃毛 / 短剪：貓的皮膚較薄，刀片極易刮傷，剃毛後可能出現紅疹、發癢或暫時性禿斑屬正常現象，本店已盡力避免但不保證完全無痕。

6. 隱睪、皮膚病、跳蚤、耳蟎：如發現上述情況本店會立即通知家長並建議先就醫；本店保留拒絕服務權利。

7. 緬因貓 / 長毛貓：因毛量及體型較大，所需時間及收費會高於一般家貓，按照本店「特殊品種定價」計算。

8. 等候交收：完成後請準時接回；如逾時超過 30 分鐘，會另收每小時 $50 看顧費。

家長確認即表示已閱讀並理解以上須知，並同意以家長身份為貓貓承擔相關風險。`;

// Senior threshold (years) — pets at or above this trigger the senior disclaimer
// during booking. Pet-grooming industry convention is 10+ (vs 7+ in vet care)
// because the procedure is short, low-stress, and not pharmacologically risky.
export const SENIOR_AGE_YEARS = 10;
